module.exports = __webpack_public_path__ + "fonts/Inter-100-latin-ext9.fad2a54.woff2";